import React, { useCallback, useEffect, useState, useRef } from "react";
import styled from "styled-components";
import axios from "axios";
import { useRouter } from "next/router";

import { usePrevious } from "../../../hooks";

import ContactUsReceivedSection from "../../sections/ContactUsReceivedSection";
import ContactUsHeaderSection from "../../sections/ContactUsHeaderSection";
import FormSection from "../../sections/FormSection";
import TitleSectionFederal from "../../V2-federal/sections/TitleSection";
import ContactUsReceivedSectionFederal from "../../V2-federal/sections/ContactUsReceivedSection";
import ContactUsReceivedSectionFileForEin from "../../V2-fileforein/sections/ContactUsReceivedSection";
import FormSectionFederal from "../../V2-federal/sections/FormSection";
import FormSectionFileforein from "../../V2-fileforein/sections/FormSection";
import TitleSectionReflection1 from "../../V2-reflection-1/sections/TitleSection";
import ContactUsReceivedSectionReflection1 from "../../V2-reflection-1/sections/ContactUsReceivedSection";
import FormSectionReflection1 from "../../V2-reflection-1/sections/FormSection";
import TitleSectionReflection2 from "../../V2-reflection-2/sections/TitleSection";
import ContactUsReceivedSectionReflection2 from "../../V2-reflection-2/sections/ContactUsReceivedSection";
import FormSectionReflection2 from "../../V2-reflection-2/sections/FormSection";
import TitleSectionReflection3 from "../../V2-reflection-3/sections/TitleSection";
import ContactUsReceivedSectionReflection3 from "../../V2-reflection-3/sections/ContactUsReceivedSection";
import FormSectionReflection3 from "../../V2-reflection-3/sections/FormSection";
import TitleSectionReflection4 from "../../V2-reflection-4/sections/TitleSection";
import ContactUsReceivedSectionReflection4 from "../../V2-reflection-4/sections/ContactUsReceivedSection";
import FormSectionReflection4 from "../../V2-reflection-4/sections/FormSection";

import { getHostname } from "../../../../helpers/common";

const StyledContactUsPage = styled.div`
  display: flex;
  flex-direction: column;

  min-height: calc(100vh - 70px);

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: calc(100vh - 70px);
  }
`;

function ContactUsPage() {
  const router = useRouter();
  const captchaRef = useRef(null);
  const [reCaptchaToken, setReCaptchaToken] = useState(null);
  const [state, setState] = useState({
    customerEmail: "",
    customerFirstName: "",
    customerLastName: "",
    customerMiddleName: "",
    customerPhone: null,
    validated: false,
    questionsOrder: "true",
    orderId: null,
    message: null,
    error: null,
    isSended: false,
    loading: false,
    verifying: false,
    suspendedSubmit: false,
  });

  const prevState = usePrevious(state);

  const handleReCaptcha = (token) => {
    setReCaptchaToken(token);
  };

  const handleChange = (e) => {
    if (e.target.name) {
      setState(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    } else {
      setState(prevState => ({ ...prevState, [e.target.id]: e.target.value }));
    }
  };

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    if (state.verifying) {
      return;
    }

    setState(prevState => ({ ...prevState, suspendedSubmit: false }));

    const form = e.currentTarget;
    const section = document.querySelector(".is-invalid");

    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      if (form.checkValidity() === false) {
        document.querySelector(".form-control:invalid")?.scrollIntoView({ behavior: "smooth", block: "start" });
  
        if (captchaRef?.current) {
          captchaRef.current.reset();
        }
  
      } else {
        e.preventDefault();
        setState(prevState => ({ ...prevState, loading: true }));
  
        const contactus = {
          name: `${state.customerFirstName} ${state.customerMiddleName} ${state.customerLastName}`,
          email: state.customerEmail,
          message: state.message,
          orderId: state.orderId,
          phone: state.customerPhone,
          domain: getHostname(),
        };
  
        axios
          .post(process.env.NEXT_PUBLIC_REACT_APP_API + "/contact-us", contactus, { headers: { "Content-Type": "application/json" } })
          .then((response) => {
            setState(prevState => ({ ...prevState, isSended: true, loading: false }));
          })
          .catch((error) => {
            setState(prevState => ({ ...prevState, error: true, loading: false }));
          });
      }
    }

    setState(prevState => ({ ...prevState, validated: true }));
    setReCaptchaToken(null);
  }, [state]);

  useEffect(() => {
    if (prevState?.verifying && !state.verifying && state.suspendedSubmit) {
      document.getElementById("ContactUsSubmitButton")?.click();
    }
  }, [state, prevState]);

  if (state.isSended || state.loading) {
    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid") {
      return (
        <StyledContactUsPage>
          <TitleSectionFederal title="Contact Us" />
          <ContactUsReceivedSectionFederal loading={state.loading} />
        </StyledContactUsPage>
      );
    }
    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
      return (
        <StyledContactUsPage>
          <TitleSectionFederal title="Contact Us" />
          <ContactUsReceivedSectionFileForEin loading={state.loading} />
        </StyledContactUsPage>
      );
    }
    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
      return (
        <StyledContactUsPage>
          <TitleSectionReflection1 title="Contact Us" />
          <ContactUsReceivedSectionReflection1 loading={state.loading} />
        </StyledContactUsPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
      return (
        <StyledContactUsPage>
          <TitleSectionReflection2 title="Contact Us" />
          <ContactUsReceivedSectionReflection2 loading={state.loading} />
        </StyledContactUsPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
      return (
        <StyledContactUsPage>
          <TitleSectionReflection3 title="Contact Us" />
          <ContactUsReceivedSectionReflection3 loading={state.loading} />
        </StyledContactUsPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
      return (
        <StyledContactUsPage>
          <TitleSectionReflection4 title="Contact Us" />
          <ContactUsReceivedSectionReflection4 loading={state.loading} />
        </StyledContactUsPage>
      );
    }

    return (
      <StyledContactUsPage>
        <ContactUsHeaderSection />
        <ContactUsReceivedSection loading={state.loading} />
      </StyledContactUsPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid") {
    return (
      <StyledContactUsPage>
        <TitleSectionFederal title="Contact Us" />
        <FormSectionFederal
          ref={captchaRef}
          path={router.pathname}
          values={state}
          onReCaptcha={handleReCaptcha}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledContactUsPage>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
    return (
      <StyledContactUsPage>
        <TitleSectionFederal title="Contact Us" />
        <FormSectionFileforein
          ref={captchaRef}
          path={router.pathname}
          values={state}
          onReCaptcha={handleReCaptcha}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledContactUsPage>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
    return (
      <StyledContactUsPage>
        <TitleSectionReflection1 title="Contact Us" />
        <FormSectionReflection1
          ref={captchaRef}
          path={router.pathname}
          values={state}
          onReCaptcha={handleReCaptcha}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledContactUsPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
    return (
      <StyledContactUsPage>
        <TitleSectionReflection2 title="Contact Us" />
        <FormSectionReflection2
          ref={captchaRef}
          path={router.pathname}
          values={state}
          onReCaptcha={handleReCaptcha}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledContactUsPage>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
    return (
      <StyledContactUsPage>
        <TitleSectionReflection3 title="Contact Us" />
        <FormSectionReflection3
          ref={captchaRef}
          path={router.pathname}
          values={state}
          onReCaptcha={handleReCaptcha}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledContactUsPage>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
    return (
      <StyledContactUsPage>
        <TitleSectionReflection4 title="Contact Us" />
        <FormSectionReflection4
          ref={captchaRef}
          path={router.pathname}
          values={state}
          onReCaptcha={handleReCaptcha}
          onChange={handleChange}
          onSubmit={handleSubmit}
        />
      </StyledContactUsPage>
    );
  }
  return (
    <StyledContactUsPage>
      <ContactUsHeaderSection />
      <FormSection
        ref={captchaRef}
        path={router.pathname}
        values={state}
        onReCaptcha={handleReCaptcha}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </StyledContactUsPage>
  );
}

export default ContactUsPage;
